var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DomVirtualContentRenderer } from '@syncfusion/ej2-grids';
/**
 * DomVirtualTreeContentRenderer extends Grid's DOM virtualization rendering layer to provide tree-specific hierarchy support.
 *
 * @hidden
 */
var DomVirtualTreeContentRenderer = /** @class */ (function (_super) {
    __extends(DomVirtualTreeContentRenderer, _super);
    /**
     * Constructor for DomVirtualTreeContentRenderer
     *
     * @param {IGrid} parent - Grid/TreeGrid instance
     * @param {ServiceLocator} locator - Service locator for dependency injection
     */
    function DomVirtualTreeContentRenderer(parent, locator) {
        var _this = _super.call(this, parent, locator) || this;
        _this.addEventListener();
        return _this;
    }
    DomVirtualTreeContentRenderer.prototype.addEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
    };
    DomVirtualTreeContentRenderer.prototype.removeEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
    };
    DomVirtualTreeContentRenderer.prototype.destroy = function () {
        this.removeEventListener();
        _super.prototype.destroy.call(this);
    };
    return DomVirtualTreeContentRenderer;
}(DomVirtualContentRenderer));
export { DomVirtualTreeContentRenderer };
